export default {
  GET_CONFIG_INDEX: '/api/exam/practice/getConfig',         // 模拟考试联系首页配置信息
  
  GET_CONFIG: '/api/exam/practice/getConf'                  // 模拟考试联系首页配置信息
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/dome.js